import { render, staticRenderFns } from "./index.vue?vue&type=template&id=697fe0da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=697fe0da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697fe0da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('697fe0da')) {
      api.createRecord('697fe0da', component.options)
    } else {
      api.reload('697fe0da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=697fe0da&scoped=true", function () {
      api.rerender('697fe0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabSearch/index.vue"
export default component.exports